/* global MODE */

var _ = require('lodash');
var ToolBar = require('./' + MODE + '/ToolBar');
var Constants = require('./ToolBarConstants');



var namespace = {
};
_.extend(namespace, Constants);
_.extend(ToolBar, namespace);

module.exports = ToolBar;



//////////////////
// WEBPACK FOOTER
// ./src/DMap/Toolbar/ToolBarNamespace.js
// module id = 430
// module chunks = 0